export const formatBytes = (bytes: number, decimals: number = 2): Number => {
  if (bytes === 0) return 0;

  const k = 1024;

  return parseFloat((bytes / (k * k)).toFixed(2));
};
